import React from 'react';
import { Box, ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

export const Concierge: React.FC = () => {
  const { tq } = useTranslation('eventWorkspace');

  return (
    <Flex
      width={'100%'}
      height={'100%'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      rowGap={6}
      padding={9}
    >
      <TextV2
        typographyVariant="hed4"
        textAlign="center"
      >
        {tq`Make Planning Simple with Joy Concierge`}
      </TextV2>
      <Box>
        <TextV2>{tq`Joy offers concierge services for venues, marketing materials, event swag, and more. Use the link below to submit a concierge request and our team will be in touch within 24 business hours.`}</TextV2>
      </Box>
      <ButtonV2 intent="newPrimary">{tq`Create Request`}</ButtonV2>
    </Flex>
  );
};
